import { z } from 'zod';
import { SafeStringSchema } from '../types/CommonSchemas';

export const ModemSettingsSchema = z.object({
    rtspUrl: SafeStringSchema,
    fpvMode: z.boolean(),
    fpvLatency: z.number()
});

export type ModemSettingsData = z.infer<typeof ModemSettingsSchema>;

export interface ModemSettingsSaveSettingRequestData {
    imei: string;
    rtspUrl: string;
    fpvMode: boolean;
    fpvLatency: string;
}
